import React from 'react'

const About = () => {
  return (
    <section className='about-section'>
      <h1 className='section-title'>about us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore, aut
        deserunt. Delectus libero rem, esse, repudiandae odio quia culpa
        assumenda eius laboriosam vel ratione! Dolor numquam quasi quam modi
        eligendi officia dolorum porro! Obcaecati doloremque fugit sed minus,
        fuga qui.
      </p>
    </section>
  )
}

export default About
